import React from 'react'
// components
import { ReduxInput, ReduxSelect } from 'components/FormElements'
// constants
import { FORMAT_OPTIONS } from 'constants/objects'

interface Props {
  isForm: boolean
}

const NumberSettings: React.FC<Props> = ({ isForm }) => {
  return (
    <>
      <ReduxSelect isClearable name='format' label='Format' options={FORMAT_OPTIONS} />
      {isForm && (
        <>
          <ReduxInput name='settings.minRange' label='Minimum range' type='number' />
          <ReduxInput name='settings.maxRange' label='Maximum range' type='number' />
        </>
      )}
    </>
  )
}

export default NumberSettings
